import type { PolicyDriver } from "@shared/schema";

/**
 * Resolve a human-readable driver name from a `PolicyDriver`.
 *
 * Prefers the canonical `name` field (set by sync-time normalization or
 * manual edits). Falls back to combining `firstName` and `lastName` for
 * legacy rows synced from the Data Center before normalization landed.
 * Returns "Unknown driver" when no name information is present.
 */
export function getDriverDisplayName(d: PolicyDriver): string {
  if (d.name && d.name.trim()) return d.name.trim();
  const combined = [d.firstName, d.lastName]
    .filter((s): s is string => Boolean(s && s.trim()))
    .map((s) => s.trim())
    .join(" ")
    .trim();
  return combined || "Unknown driver";
}
